import { css } from "styled-components"
import { fontFamily } from "styled-system"

export default css`
	// Only show focus outline when required by WCAG
	.js-focus-visible :focus:not(.focus-visible) {
		outline: none;
	}
	@font-face {
		font-family: "proxima-nova";
		src: url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
				format("woff2"),
			url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
				format("woff"),
			url("https://use.typekit.net/af/efe4a5/00000000000000007735e609/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3")
				format("opentype");
		font-style: normal;
		font-weight: 400;
		font-stretch: normal;
	}
	@font-face {
		font-family: "proxima-nova";
		src: url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
				format("woff2"),
			url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
				format("woff"),
			url("https://use.typekit.net/af/2555e1/00000000000000007735e603/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3")
				format("opentype");
		font-style: normal;
		font-weight: 700;
		font-stretch: normal;
	}
	html {
		box-sizing: border-box;
	}
	body {
		background-color: ${({ theme }) => theme.colors.bodyColor};
		color: ${({ theme }) => theme.colors.bodyTextColor};
		/* font-family: ${fontFamily}; */
	}
	*,
	*:before,
	*:after {
		box-sizing: inherit;
	}
	img  {
		max-width: 100%;
	}
	a {
		display: inline-block;
		text-decoration: none;
		color: inherit;
	}

	#legitscript a {
		position: relative;
		width: 100%;		
	}
	
	#legitscript a img {
			position: absolute;
			top: -160px;
			right: 120px;
		}

	.visually-hidden {
		clip: rect(0 0 0 0);
		clip-path: inset(50%);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}
`
